import React, { useRef } from "react";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function HaldiImage({haldiimage}) {
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 3,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,
        swipe: false,
        responsive: [
            {
            breakpoint: 991,
            settings: { slidesToShow: 3, draggable: true, swipe: true, autoplay: true, },
            },
            {
                breakpoint: 767,
                settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true, },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true,}
            },
        ],
    };

    const CustomArrows = () => (
        <>
        <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
            <Icons name="arrowLeft" />
        </div>
        <div className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
            <Icons name="arrowRight" />
        </div>
        </>
    );

  return (
    <>
    <section className="haldipage-image">
        <div className="container">
            <div className="row">
    
                <div className="col-lg-12">
                    <div className="p-relative">
                        <Slider {...settings} ref={sliderRef}>
                        {haldiimage.map((img, ind) => (
                            <img key={ind} src={img.src} className="img-responsive" alt={img.alt} loading="lazy"/>
                        ))}
                        </Slider>
                        <CustomArrows />
                    </div>
                </div>
    
            </div>
        </div>
    </section> 
    </>
  )
}
